import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
  transform: skew(-30deg);
  padding: 10px 40px;
  background-color: #01788A;
  text-align: center;

  & > * {
    display: inline-block;
    transform: skew(30deg);
  }
`;

const SpeedyTag = ({ children, className }) => (
  <Wrapper className={className}>
    {children}
  </Wrapper>
);

export default SpeedyTag;
